"use strict";
import { BaseCsvParser } from "./BaseCsvParser";
export class ApplicationsCsvParser extends BaseCsvParser {
  /**
   * Get the list of required columns for applications CSV
   * @returns Array of required column names
   */
  getRequiredColumns() {
    return ["id", "entity_id", "state", "source_type", "source_name", "created_at"];
  }
  /**
   * Validate if an application record has all required fields
   * @param record The record to validate
   * @returns True if the record is valid, false otherwise
   */
  validateRecord(record) {
    return !!(record["id"] && record["entity_id"] && record["state"] && record["source_type"] && record["source_name"] && record["created_at"]);
  }
  /**
   * Create an application object from the parsed CSV record
   * @param record The parsed CSV record
   * @param headers The CSV headers (not used in this implementation)
   * @returns The application object
   */
  createRecordObject(record, headers) {
    return {
      id: record["id"],
      entity_id: record["entity_id"],
      state: record["state"],
      source_type: record["source_type"],
      source_name: record["source_name"],
      created_at: record["created_at"]
    };
  }
}
